// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3TUvp","upload":"Small_upload__2TcRf","imageWrap":"Small_imageWrap__2n3RK","removeBtn":"Small_removeBtn__1Z8dp"};